import { type QueryKey, useQuery } from '@tanstack/react-query'

import { listConversations } from './api'
import { CONVERSATIONS_LIST_KEY } from './keys'

/** search keys off the base list key so socket-side invalidations (new
 * message, new conversation) still hit search-scoped queries . react
 * query invalidates by prefix when the keys share the leading slice.
 */
export function useConversations(args: { search?: string } = {}) {
  const trimmed = args.search?.trim() ?? ''
  const queryKey: QueryKey = trimmed
    ? [...CONVERSATIONS_LIST_KEY, { search: trimmed }]
    : CONVERSATIONS_LIST_KEY
  return useQuery({
    queryKey,
    queryFn: ({ signal }) =>
      listConversations({ search: trimmed || undefined }, signal),
    staleTime: 30_000
  })
}
